import { palette } from "lib/miolo";
import IconCard, { CardDescription, CardValue } from "components/company/v2/cards/IconCard";
import TextTooltip from "components/shared/TextTooltip";
import { formatDistanceStrict, lightFormat } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import parseDateYmd from "lib/utils/parseDateYmd";

interface INextUpcomingCalendarEventCardProps {
  issuer: IBrazilianCompanyIssuerTopLevelFragment;
}

export default function NextUpcomingCalendarEventCard({ issuer }: INextUpcomingCalendarEventCardProps) {
  if (!issuer.nextUpcomingCalendarEvent) {
    return null;
  }

  const icon = (
    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 22 22">
      <g transform="translate(-27 -34)" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <path
          stroke="currentColor"
          strokeWidth={2}
          d="M28 40.333a2.667 2.667 0 012.667-2.666h14a2.667 2.667 0 012.666 2.666v11.334a2.667 2.667 0 01-2.666 2.666h-14A2.666 2.666 0 0128 51.667V40.333zM32.333 35v4.667M43 35v4.667M32 43h11.333"
        />
      </g>
    </svg>
  );

  const eventDate = parseDateYmd(issuer.nextUpcomingCalendarEvent.eventDate);

  return (
    <div>
      <IconCard primaryColor={palette.mojo} secondaryColor={palette.vanillaIce} icon={icon}>
        <CardValue>
          <TextTooltip
            id="NextUpcomingCalendarEventCard"
            placement="top"
            content={`Daqui ${formatDistanceStrict(eventDate, new Date(), { locale: ptBR })}`}
            style={{
              maxWidth: 260,
              textAlign: "center",
            }}
          >
            {({ accessibility, bind, ref }) => (
              <span {...accessibility} {...bind} ref={ref}>
                {lightFormat(eventDate, "dd/MM/yyyy")}
              </span>
            )}
          </TextTooltip>
        </CardValue>
        <CardDescription>{issuer.nextUpcomingCalendarEvent.eventLabel}</CardDescription>
      </IconCard>
    </div>
  );
}
